<div class="content-label-container">
    <h1 [style.color]="titleColor" translate>navigation.info</h1>
    <p translate>info.subtitle</p>
</div>

<div class="content-main-container">
    <div fxLayout="row wrap" fxLayoutAlign="space-around start" class="fxbox">
        <ng-container *ngFor="let info of informations">
            <div class="checkbox_area">
                <mat-checkbox [color]="info.color" [(ngModel)]="info.checked">
                    {{ info.tag | translate }}
                </mat-checkbox>
                <ng-container *ngIf="info.tooltip">
                    <mat-icon 
                        #tooltip="matTooltip"
                        (click)="tooltip.toggle()"
                        matTooltip="{{info.tooltip | translate}}"
                        matTooltipPosition="above">
                        help_outline
                    </mat-icon>
                </ng-container>
            </div>
        </ng-container>
    </div>
    <p *ngIf="IsMobile()" class="help" translate>
        ※<mat-icon>help_outline</mat-icon>info.help
    </p>
    <div class="dropdown_list">
        <mat-select placeholder="{{ placeholder | translate }}" [(ngModel)]="pref">
            <mat-optgroup 
                *ngFor="let group of prefecture"
                [label]="group.name" 
                [disabled]="group.disabled">
                <mat-option *ngFor="let pref of group.prefectures" [value]="pref.viewValue">
                    {{ pref.viewValue }}
                </mat-option>
            </mat-optgroup>
        </mat-select>
    </div>
    <div class="search_btn">
        <button 
            (click)="onClick()"
            mat-raised-button
            color="primary">
            <mat-icon>search</mat-icon>
            {{ buttonLabel | translate }}
        </button>
    </div>
</div>